module.exports = __webpack_public_path__ + "static/media/Album 3.40cdf163.png";